import React, {Component} from 'react';
import PropTypes from 'prop-types';
import MemoryModel from "../models/MemoryModel";
import Card from "@material-ui/core/Card"
import TextField from '@material-ui/core/TextField';
import {CardHeader} from "@material-ui/core";
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';
import ReduceIcon from '@material-ui/icons/Remove'
import AnswerView from "./AnswerView"
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import FormControl from "@material-ui/core/FormControl";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {useTheme} from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Button from '@material-ui/core/Button';


let dataSource = [];
let refs_Key = [];
let refs_Value = [];
let tempType = "";

const styles = {
    container: {
        // background: "red",
        width: "100%",
        // height: "100%"
    },
    table: {
        margin: 10,
        // background:"blue",
        // flex: 1,
        // borderSpacing: 10,
        // width: "100%",
    },
    item: {
        width: "100%",
        // height:24,
        display: "flex",
    },
    formControl: {
        margin: 8,
        minWidth: 120,
    },
    textField: {
        height: "100%",
        flex: 1,
        marginLeft: 8,
        marginRight: 8,
    },
};

class MemoryView extends Component {
    static propTypes = {
        // //点击触发的方法
        onFinish: PropTypes.func,
    };
    state = {
        itemType: "",
        showDialog: false,
    };

    constructor(props) {
        super(props);
        this.inputLabel = React.createRef();
    }

    componentWillMount() {
        this.state.itemType = "关键字";
        this.addMatch();
    }

    onFinishMemroyAction = (e) => {
        if (e.keyCode === 13) {
            let data = {};
            for (var i = 0; i < refs_Key.length; i++) {
                let textInput_Key = refs_Key[i];
                let textInput_Value = refs_Value[i];
                let key = textInput_Key.current.value;
                let value = textInput_Value.current.value;
                if (key === "" || value === "") {
                    if (i === refs_Key.length-1){
                        continue;
                    }else {
                        var msg = "第" + (i + 1) + "行 " + this.state.itemType+ " 或 应答 不能为空 ";
                        alert(msg);
                        return;
                    }

                }
                if (key in data) {
                    let v = data[key];
                    if (v.indexOf(value) < 0) {
                        v.push(value);
                    }
                } else {
                    let v = [];
                    v.push(value);
                    data[key] = v;
                }
            }
            let result = {
                "type": this.state.itemType,
                "data": data,
            };
            this.props.onFinish(result);
            let textInput_Key = refs_Key[refs_Key.length-1];
            let textInput_Value = refs_Value[refs_Value.length-1];
            let key = textInput_Key.current.value;
            let value = textInput_Value.current.value;
            if (key === "" || value===""){
                return;
            }
            this.addMatch();
        }
    };

    addMatch = () => {
        let textInput_Key = React.createRef();
        refs_Key.push(textInput_Key);
        let textInput_Value = React.createRef();
        refs_Value.push(textInput_Value);
        let i = refs_Key.length - 1;
        var key = ( new Date()).valueOf();
        dataSource.push(
            <div key={"match" + key} style={styles.item}>
                <TextField
                    id="type"
                    label={this.state.itemType}
                    style={styles.textField}
                    placeholder={this.state.itemType}
                    margin="normal"
                    variant="outlined"
                    inputRef={refs_Key[i]}
                    autoFocus={true}
                />
                <TextField style={styles.textField} id="type"
                           label="应答"
                           placeholder="应答"
                           margin="normal"
                           variant="outlined"
                           onKeyUp={this.onFinishMemroyAction}
                           inputRef={refs_Value[i]}
                />
            </div>
        );
        this.setState({
            showDialog:false,
        })
    };
    addItem = () => {
        this.addMatch();
    };
    deleteItem = () => {
        refs_Key.pop();
        refs_Value.pop();
        dataSource.pop();
        this.setState({});
    };

    handleSelectItem = name => event => {
        tempType = event.target.value;
        if (this.state.itemType !== tempType) {
            this.setState({
                showDialog: true,
            })
        }
    };

    handleClose = () => {
        this.setState({
            showDialog: false,
        })
    };
    changeItemType = () => {
        dataSource = [];
        refs_Key = [];
        refs_Value = [];
        this.state.itemType = tempType;
        this.addMatch();
    };
    // render() {
    //     return <Card style={{width:"50%",height:"150%",background:"red"}}></Card>
    // }

    render() {
        return (
            <Card style={styles.container}>
                <CardHeader
                    avatar={
                        <Avatar>
                            Mat
                        </Avatar>}
                    title="Match"
                    action={
                        <div>
                            <FormControl variant="outlined" style={styles.formControl}>
                                <InputLabel ref={this.inputLabel} htmlFor="itemType">
                                    itemType
                                </InputLabel>
                                <Select
                                    native
                                    value={this.state.itemType}
                                    onChange={this.handleSelectItem('itemType')}
                                    input={
                                        <OutlinedInput name="itemType" labelWidth={65} id="itemType"/>
                                    }
                                >
                                    <option value="关键字">关键字</option>
                                    <option value="近似句">近似句</option>
                                    <option value="语境">语境</option>
                                    <option value="开场白">开场白</option>



                                </Select>
                            </FormControl>
                            <IconButton aria-label="Add"
                                        onClick={this.addItem}>
                                <AddIcon/>
                            </IconButton>
                            <IconButton aria-label="Remove"
                                        onClick={this.deleteItem}>
                                <ReduceIcon/>
                            </IconButton>
                        </div>
                    }
                >
                </CardHeader>
                <div style={styles.table}>
                    {dataSource}
                </div>
                <Dialog
                    fullScreen={false}
                    open={this.state.showDialog}
                    onClose={this.handleClose}
                    aria-labelledby="responsive-dialog-title"
                >
                    <DialogTitle id="responsive-dialog-title">{"更换类型"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            更换类型后，当前编辑的内容将被清空，是否继续？
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="default" autoFocus>
                            取消
                        </Button>
                        <Button onClick={this.changeItemType} color="primary" >
                            确定
                        </Button>
                    </DialogActions>
                </Dialog>
            </Card>

        );
    }
}

export default MemoryView;
